// src/pages/CourseTime/components/slides/layouts/ListSlide.comp.jsx
import React from 'react';
import * as S from '../../../styles';
import KeyPointsList from '../common/KeyPointsList.comp';
import SlideTitleSpoken from '../common/SlideTitleSpoken.comp';
import { useSlideContentRenderer } from '../../../hooks/useSlideContentRenderer';

// Layout: TemplateList
const ListSlide = ({ slide, renderSpokenText, skipTitleSpeech }) => {
  const { renderContent, renderHtmlWithSpeech, fixHtml } = useSlideContentRenderer({ renderSpokenText, skipTitleSpeech });

  // SlideContent is sometimes a real array (one entry per bullet), and
  // sometimes a single string with bullets separated by "\n- "/"\n• " —
  // split the latter into one item per line so each bullet renders as
  // its own <li> instead of the whole string collapsing into one.
  const cleanItems = Array.isArray(slide.SlideContent)
      ? slide.SlideContent.filter(Boolean)
      : String(slide.SlideContent || '').split('\n').map(s => s.trim()).filter(Boolean);

  const origin = slide._pbdq_origin || slide;
  const isKeyPoints = slide._pbdq_kind === 'key_points' || origin.slide_type === 'key_points';

  if (isKeyPoints) {
    const intro = origin.intro_line || '';
    const closing = origin.closing_line || '';
    const points = origin.points || [];

    let parsedPoints = points;
    if ((!parsedPoints || parsedPoints.length === 0) && cleanItems && cleanItems.length > 0) {
      parsedPoints = cleanItems.map(item => {
        const str = String(item).trim();
        // Clean leading bullets if present
        const cleanStr = str.replace(/^[•\-*\s]+/, '');
        // Extract emoji if present at start
        const emojiMatch = cleanStr.match(/^([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])\s*(.*)$/);
        let icon = '';
        let rest = cleanStr;
        if (emojiMatch) {
          icon = emojiMatch[1];
          rest = emojiMatch[2];
        }
        // Extract verb_phrase and description split by ' — ' or ': '
        const parts = rest.split(/\s*[\u2014\-:]\s*/);
        let verb_phrase = rest;
        let description = '';
        if (parts.length > 1) {
          verb_phrase = parts[0];
          description = parts.slice(1).join(' — ');
        }
        return { icon, verb_phrase, description };
      });
    }

    return (
      <KeyPointsList
        slide={slide}
        skipTitleSpeech={skipTitleSpeech}
        renderSpokenText={renderSpokenText}
        intro={intro}
        closing={closing}
        points={parsedPoints}
      />
    );
  }

  return (
      <S.SlideList>
        <S.SlideTitle>
          <SlideTitleSpoken slide={slide} skipTitleSpeech={skipTitleSpeech} renderSpokenText={renderSpokenText} />
        </S.SlideTitle>

        <ul>
          {cleanItems.map((item, idx) => {
            const text = fixHtml(String(item).trim());
            const cleanText = text.replace(/^[•\-*\s]+/, '');
            const hasTag = /<li[^>]*>/i.test(cleanText);

            if (hasTag) {
                return (
                    <li
                        key={idx}
                        style={{ listStyleType: "none", marginLeft: 0, paddingLeft: 0 }}
                    >
                        {renderHtmlWithSpeech(`content_${idx}`, cleanText)}
                    </li>
                );
            }

            return (
              <li key={idx}>
                <S.PointText>
                  {renderContent(`content_${idx}`, cleanText)}
                </S.PointText>
              </li>
            );
          })}
        </ul>
      </S.SlideList>
  );
};

export default ListSlide;
